import classNames from 'classnames'
import React, { Component } from 'react'
import Spinner from 'react-spinner'
import 'react-spinner/react-spinner.css'
import C from '../Const'
import ReactClickOutside from '../lib/react-click-outside'
import R from '../ramda'
import U from '../Utils'
import './MenuFilterPopup.css'

class MenuFilterPopup extends Component {
  constructor(props) {
    super(props)

    this.state = {
      // elementi selezionati, inizialmente uguali al filtro attivo
      selected_ids: props.values,

      // elementi espansi (+/-) manualmente (esclusi quelli espansi
      // automaticamente perché contengono children selezionati)
      expanded_ids: {},

      // flag usato tra onMouseDown su un elemento e onMouseEnter in un altro
      // per ricordarsi se l'utente sta selezionando o de-selezionando elementi
      is_selecting: null,

      // usato solo nei popup is_big:
      // flag che mostra nell'albero solo gli elementi selezionati
      show_only_selected: !R.isEmpty(props.values),

      // usato solo nei popup is_big:
      // testo di ricerca corrente
      search: null,
    }
  }

  componentDidMount() {
    if (this.searchRef) {
      this.searchRef.focus()
    }
  }

  // ------------------------------------------ HANDLERS ------------------------------------------

  handleSelect(item, path, continue_select) {
    let { isSingleSelect } = this.props
    let { id, children } = item
    let lev = path.length + 1
    this.setState((prevState) => {
      let newState = {}
      if (continue_select) {
        newState.is_selecting = prevState.is_selecting
      } else {
        newState.is_selecting = !prevState.selected_ids[id]
      }
      if (!newState.is_selecting) {
        newState.selected_ids = U.unset(id)(prevState.selected_ids)
      } else if (isSingleSelect) {
        newState.selected_ids = { [id]: lev }
      } else {
        // la selezione di un item causa la de-selezione di tutti i suoi
        // parent (path) e di tutti gli elementi contenuti (children)
        newState.selected_ids = R.compose(
          U.set(id, lev),
          U.unset(R.concat(path, this.allItemIds(children))),
        )(prevState.selected_ids)
      }
      if (R.isEmpty(newState.selected_ids)) {
        newState.show_only_selected = false
      }
      return newState
    })
  }

  handleExpand(id, do_expand) {
    this.setState((prevState) => ({
      expanded_ids: (do_expand ? U.set(id, true) : U.unset(id))(prevState.expanded_ids),
      show_only_selected: false,
    }))
  }

  handleApply() {
    let { selected_ids } = this.state
    let descr = this.getFilterDescr(selected_ids)
    this.props.onChange(selected_ids, descr)
    this.props.onClose()
  }

  handleReset() {
    this.props.onChange({})
    this.props.onClose()
  }

  handleClickOutside() {
    this.props.onClose()
  }

  handleShowOnlySelected(show_only_selected) {
    this.setState({
      show_only_selected,
      expanded_ids: {},
    })
  }

  handleSearch(search) {
    this.setState((prevState) => {
      let newState = { search }
      if (!!search !== !!prevState.search) {
        newState.expanded_ids = {}
        newState.show_only_selected = !R.isEmpty(prevState.selected_ids)
      }
      return newState
    })
  }

  // ------------------------------------------ UTILITY -------------------------------------------

  countItems(items) {
    if (!items) {
      return 0
    }
    return R.sum(R.map((item) => 1 + this.countItems(item.children))(items))
  }

  // funzione ricorsiva che ritorna:
  //  - 1 se l'item è selezionato (state.selected_ids)
  //  - 2 se contiene elementi selezionati
  //  - 0 altrimenti
  isOrContainsSelected(item) {
    let { selected_ids } = this.state
    let { id, children } = item

    if (selected_ids[id]) {
      return 1
    }
    if (children && children.some((c) => this.isOrContainsSelected(c))) {
      return 2
    }
    return 0
  }

  // funzione ricorsiva che ritorna:
  //  - 1 se l'item fa match con la ricerca (state.search)
  //  - 2 se contiene contiene elementi che fanno match
  //  - 0 altrimenti
  isOrContainsSearch(item) {
    let { search } = this.state
    let { label, children } = item

    if (new RegExp(search, 'i').test(label)) {
      return 1
    }
    if (children && children.some((c) => this.isOrContainsSearch(c))) {
      return 2
    }
    return 0
  }

  // funzione che accetta una label e ritorna un array di elementi ReactDOM
  // per evidenziane le parti che corrispondono alla ricerca corrente
  highlightSearch(label) {
    let { search } = this.state
    if (!search) return label
    let out = [],
      pos = 0,
      re = new RegExp(search, 'ig'),
      match
    // eslint-disable-next-line no-cond-assign
    while ((match = re.exec(label))) {
      if (match.index > pos) {
        out.push(label.substr(pos, match.index))
      }
      out.push(<strong key={match.index}>{match[0]}</strong>)
      pos = match.index + match[0].length
    }
    if (pos < label.length) {
      out.push(label.substr(pos))
    }
    return out
  }

  // accetta un array di items (oppure null) e ritorna un array appiattito
  // con gli id di tutti gli items e dei loro discendenti
  allItemIds(items) {
    if (!items) {
      return []
    }
    return R.chain((item) => R.concat([item.id], this.allItemIds(item.children)))(items)
  }

  // crea un array con le descrizioni dei filtri selezionati
  getFilterDescr(selected_ids) {
    let descr = []
    walk(this.props.items)
    return descr

    function walk(items) {
      items.forEach(({ id, label, children }) => {
        if (R.has(id, selected_ids)) {
          descr.push(label.trim())
        }
        if (children) {
          walk(children)
        }
      })
    }
  }

  // ------------------------------------------- RENDER -------------------------------------------

  preRender() {
    // flag che modifica il funzionamento se l'albero contiene molti elementi
    this.is_big = this.countItems(this.props.items) > 50
  }

  renderHide() {
    let { show_only_selected } = this.state

    return (
      <div className="FilterPopup-hide">
        <input
          id="FilterPopup-hide"
          type="checkbox"
          checked={show_only_selected}
          onChange={(ev) => this.handleShowOnlySelected(ev.target.checked)}
        />
        <label htmlFor="FilterPopup-hide">Mostra solo elementi selezionati</label>
      </div>
    )
  }

  renderSearch() {
    let { search } = this.state

    return (
      <div className="FilterPopup-search">
        <input
          type="search"
          className="form-control input-sm"
          value={search || ''}
          onChange={(ev) => this.handleSearch(ev.target.value)}
          onFocus={(ev) => ev.target.select()}
          ref={(ref) => {
            this.searchRef = ref
          }}
        />
      </div>
    )
  }

  // funzione ricorsiva che crea la struttura ul/li con gli elementi del filtro
  //
  // sia l'espansione (+/-) che la selezione (check) sono gestite in React,
  // non in CSS, per evitare di creare nel DOM migliaia di elementi
  renderItems(items, path) {
    let { selected_ids, expanded_ids, show_only_selected, search } = this.state
    return (
      <ul>
        {items.map((item) => {
          let { id, label, children } = item
          let selected = selected_ids[id],
            contains_selected = false
          let hidden, force_expanded, disabled
          if (search) {
            let s = this.isOrContainsSearch(item)
            let is_or_contains_search = s !== 0,
              contains_search = s === 2
            hidden = !is_or_contains_search
            force_expanded = contains_search
            disabled = contains_search
          } else {
            let s = this.isOrContainsSelected(item)
            let is_or_contains_selected = s !== 0
            contains_selected = s === 2
            hidden = this.is_big && show_only_selected && !is_or_contains_selected
            force_expanded = contains_selected
            disabled = contains_selected
          }
          let expanded = force_expanded || expanded_ids[id]

          if (hidden) return null

          return (
            <li key={id} className={classNames({ selected, contains_selected })}>
              {children && (
                <span
                  className={classNames({
                    fa: true,
                    'fa-minus-square': expanded,
                    'fa-plus-square': !expanded,
                    disabled,
                  })}
                  onClick={() => !force_expanded && this.handleExpand(id, !expanded)}
                />
              )}
              <label
                onMouseDown={() => this.handleSelect(item, path, false)}
                onMouseEnter={(ev) => ev.buttons && this.handleSelect(item, path, true)}
              >
                {this.highlightSearch(label)}
              </label>
              {children && expanded && this.renderItems(children, path.concat(id))}
            </li>
          )
        })}
      </ul>
    )
  }

  render() {
    let { loading, error } = this.props

    if (loading) {
      return (
        <div className="MenuFilterPopup loading">
          <Spinner />
        </div>
      )
    }

    if (error) {
      return (
        <div className="MenuFilterPopup error">
          {C.ERRORE}
          <pre>{error}</pre>
        </div>
      )
    }

    this.preRender()

    let { items, values } = this.props
    let { selected_ids } = this.state
    let childless = R.all((it) => !it.children)(items)
    return (
      <div
        className={classNames({
          MenuFilterPopup: true,
          menu: true,
          hasHide: this.is_big,
          childless,
        })}
      >
        {this.is_big && this.renderSearch()}
        {this.renderItems(items, [])}
        <div className="buttons">
          <input
            className="btn btn-sm applica"
            type="button"
            defaultValue="Applica"
            onClick={() => this.handleApply()}
            disabled={R.equals(selected_ids, values)}
          />
          {!R.isEmpty(values) && (
            <input
              className="btn btn-sm rimuovi"
              type="button"
              defaultValue="Rimuovi Filtro"
              onClick={() => this.handleReset()}
            />
          )}
        </div>
        {this.is_big && this.renderHide()}
      </div>
    )
  }
}

export default ReactClickOutside(MenuFilterPopup)



// WEBPACK FOOTER //
// ./src/filters/MenuFilterPopup.js